import { render, staticRenderFns } from "./ChangeOrderMovementToReceived.vue?vue&type=template&id=4b069556&scoped=true"
import script from "./ChangeOrderMovementToReceived.vue?vue&type=script&lang=js"
export * from "./ChangeOrderMovementToReceived.vue?vue&type=script&lang=js"
import style0 from "./ChangeOrderMovementToReceived.vue?vue&type=style&index=0&id=4b069556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b069556",
  null
  
)

export default component.exports